// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1nV6M","label":"SetPasswdForm_label__-Os54"};